<template>
    <div id="app">
        <component :is="layout" v-if="isMounted">
            <router-view :key="$route.path" />
        </component>
        <help v-if="isMounted && authorizedUser" />
    </div>
</template>
<script>
import 'popper.js'
import 'bootstrap'
import 'bootstrap-select'
import settings from '@/settings'
import Help from '@/components/Elements/Help'
import preloadImages from '@/mixins/preloadImages'

import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'App',
    components: { Help },
    mixins: [preloadImages],
    data() {
        return {
            isMounted: false,
            authorizedUser: settings.AUTH_TOKEN
        }
    },
    computed: {
        ...mapGetters('user', ['isRetailer', 'isSupplier']),
        layout() {
            return `${this.$route.meta.layout}-layout`
        }
    },
    async mounted() {
        if (this.authorizedUser) {
            await this.getUser()
        }

        this.isMounted = true

        if (this.isRetailer) {
            this.getCart()
        }
    },
    methods: {
        ...mapActions('user', ['getUser']),
        ...mapActions('cart', ['getCart'])
    }
}
</script>
